var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.833 7.5a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.593q0-.354.24-.594t.593-.24h5.5L10.5 1.667H9.167a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.594q0-.354.24-.593.24-.24.594-.24H12.5q.354 0 .594.24t.24.593v3.334q0 .354-.24.593A.8.8 0 0 1 12.5 5a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.593V2.833L7.48 7.021a1.65 1.65 0 0 1-1.167.48zm8.334 5.833a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.593q0-.354.24-.594t.594-.24H10.5l-2.062-2.04a.8.8 0 0 1-.25-.594q0-.343.25-.594a.82.82 0 0 1 .604-.25q.354 0 .604.25l2.02 2.063V9.167q0-.354.24-.594t.594-.24.594.24.24.594V12.5q0 .354-.24.594a.8.8 0 0 1-.594.24z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowIcon);
export default __webpack_public_path__ + "static/media/workflow_icon.32951bf3f4dec3bfa9beb12419d98936.svg";
export { ForwardRef as ReactComponent };